import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { Navbar, Footer } from '../components/Layout';
import { PostCard } from './InsightsPage';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthorPage() {
  const { authorSlug } = useParams();
  const [data, setData] = useState(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    axios.get(`${API}/blog/authors/${authorSlug}`)
      .then((r) => { setData(r.data); document.title = `${r.data.author.name} | FuturePath Insights`; })
      .catch(() => setMissing(true));
  }, [authorSlug]);

  return (
    <div className="min-h-screen bg-navy-gradient">
      <Navbar />
      <div className="max-w-5xl mx-auto px-4 sm:px-6 pt-28 pb-20" data-testid="author-page">
        {missing && (
          <div className="text-center">
            <h1 className="font-outfit text-3xl font-bold text-white">Author not found</h1>
            <Link to="/insights" className="text-cyan-300 hover:text-cyan-200 text-sm mt-3 inline-block">Back to Insights</Link>
          </div>
        )}
        {data && (
          <>
            <p className="text-xs uppercase tracking-[0.2em] text-cyan-300 font-semibold">Author</p>
            <h1 className="font-outfit text-4xl font-bold text-white mt-2">{data.author.name}</h1>
            {data.author.bio && <p className="text-base text-slate-300 mt-3 max-w-2xl">{data.author.bio}</p>}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-10">
              {data.posts.map((p) => <PostCard key={p.slug} post={p} />)}
            </div>
          </>
        )}
      </div>
      <Footer />
    </div>
  );
}
